import { Metadata } from "next/types";
import { IPagePropertiesCache } from "../../types/cache";
import { ISBPageProperties } from "../../types/sb";
import { transformMetaArrayToMetadata } from "../../transformer/meta-data-transformer";
import { logError, logAdapterEvent } from "../../helper/logger";

const ADAPTER_NAME = "pagePropertiesAdapter";

interface IPagePropertiesAdapter {
  pageProperties: ISBPageProperties;
  cmsPageName?: string;
}

export function pagePropertiesAdapter(
  args: IPagePropertiesAdapter
): IPagePropertiesCache {
  try {
    logAdapterEvent(ADAPTER_NAME, "starting pageProperties adpation", {
      cmsPageName: args?.cmsPageName
    });
    const { pageProperties } = args || {};
    const canonicalLink =
      pageProperties?.link?.filter?.(item => item.rel === "canonical") || [];
    const otherLinks =
      pageProperties?.link?.filter?.(item => item.rel !== "canonical") || [];

    const meta: Metadata = transformMetaArrayToMetadata(
      pageProperties?.meta,
      pageProperties?.title,
      canonicalLink,
      args?.cmsPageName
    );

    const script =
      pageProperties?.script?.map?.(item => ({
        type: item.type,
        value: item.value,
        src: item.src,
        defer: item.defer,
        async: item.async
      })) || [];

    const bodyScript =
      pageProperties?.bodyPageProperties?.script?.map?.(item => ({
        type: item.type,
        value: item.value,
        src: item.src,
        defer: item.defer,
        async: item.async
      })) || [];
    const bodyLink = pageProperties?.bodyPageProperties?.link;

    const styles = Array.isArray(pageProperties?.styles) ? pageProperties?.styles :  pageProperties?.styles ? [pageProperties?.styles] : [];

    return {
      meta,
      link: otherLinks,
      script,
      styles,
      disableAuxNav: pageProperties.disableAuxNav,
      disableBusinessLink: pageProperties.disableBusinessLink,
      disableCheckoutTFN: pageProperties.disableCheckoutTFN,
      disableGNav: pageProperties.disableGNav,
      disableLanguageLink: pageProperties.disableLanguageLink,
      disableLinkFarm: pageProperties.disableLinkFarm,
      disableGlobalFooter: pageProperties.disableGlobalFooter,
      disableSkinnyGNav: pageProperties.disableSkinnyGNav,
      disableTFN: pageProperties.disableTFN,
      isBreadcrumbPostionTop: pageProperties.isBreadcrumbPostionTop,
      isV2Footer: pageProperties.isV2Footer,
      isV2GNav: pageProperties.isV2GNav,
      isV2LinkFarm: pageProperties.isV2LinkFarm,
      CustomerCareNum: pageProperties.CustomerCareNum,
      CustomerCareNumLabel: pageProperties.CustomerCareNumLabel,
      component: pageProperties.component,
      disableStrikeThruPricing: pageProperties.disableStrikeThruPricing,
      helpCenterInfoLabel: pageProperties.helpCenterInfoLabel,
      showPromoInCart: pageProperties.showPromoInCart,
      title: pageProperties.title,
      type: pageProperties.type,
      id: pageProperties.id,
      analytics: pageProperties.analytics,
      seo: pageProperties.seo,
      bodyPageProperties: {
        script: bodyScript,
        link: bodyLink
      },
      modalPriorityMap: pageProperties.modalPriorityMap
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      cmsPageName: args?.cmsPageName
    });
  }
}

export default pagePropertiesAdapter;
